module.exports = __webpack_public_path__ + "static/img/service_safeguard_end_1.c98a130f.png";